import { CircularProgress, List } from "@mui/material";
import React from "react";
import SpecRecipeListItem from "./SpecRecipeListItem";
import CTABlock from "../../../components/CTABlock";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import inventoryClient from "../../../clients/inventoryClient";

const SpecRecipeList = ({ recipes, isLoading }) => {
  const { establishmentid } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const copySpecRecipeMutation = useMutation(inventoryClient.copySpecRecipe, {
    onSuccess: (result) => {
      queryClient.invalidateQueries({
        queryKey: ["recipes-paginated", { establishmentId: establishmentid }],
      });
      navigate(`/spec/${establishmentid}/recipes/${result?.recipe?.id}`);
    },
  });

  const handleCopyRecipe = async (recipeId) => {
    await copySpecRecipeMutation.mutateAsync({
      establishmentId: establishmentid,
      recipeId: recipeId,
    });
  };

  return (
    <>
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {recipes?.length > 0 ? (
            <List sx={{ width: "100%", marginTop: 4 }}>
              {recipes.map((x) => (
                <SpecRecipeListItem
                  recipe={x}
                  key={x.id}
                  handleCopyRecipe={handleCopyRecipe}
                />
              ))}
            </List>
          ) : (
            <CTABlock header="No Results Found" hideButton />
          )}
        </>
      )}
    </>
  );
};

export default SpecRecipeList;
